class ProductSizeGuide extends HTMLElement {
  connectedCallback() {
    this.addTabListeners();
  }

  addTabListeners() {
    this.querySelectorAll('.size-guide-tabs').forEach(tab => {
      tab.onclick = () => this.switchTab(tab.dataset.tab, 'size-guide-tabs', 'size-guide-content');
    });
    this.querySelectorAll('.size-tabs').forEach(tab => {
      tab.onclick = () => this.switchTab(tab.dataset.tab, 'size-tabs', 'size-guide-table__container');
    });

    this.querySelectorAll('.measuring-types-tabs').forEach(tab => {
      tab.onclick = () => this.switchTab(tab.dataset.tab, 'measuring-types-tabs', 'measuring-types-content__container');
    });
  }

  switchTab(tabId, tabClass, contentClass) {
    this.querySelectorAll(`.${tabClass}`).forEach(el => el.classList.remove('active'));
    this.querySelectorAll(`.${contentClass}`).forEach(el => el.classList.remove('active'));

    this.querySelector(`.${tabClass}[data-tab="${tabId}"]`).classList.add('active');
    this.querySelector(`[data-tab-role="${tabId}"]`).classList.add('active');
  }
}

if (!customElements.get('product-size-guide')) {
  customElements.define('product-size-guide', ProductSizeGuide);
}